import React from "react";
import { createUseStyles } from "react-jss";
import { variables } from "../../variables";

const CrmStyles = createUseStyles({
  CRM: {
    display: "grid",
    overflow: "hidden",
    placeContent: "center",
  },
  title: {
    display: "grid",
    textAlign: "center",
    height: "100%",
    alignItems: "end",
    padding: variables.normal_gap,
  },
});
const CRM = () => {
  const classes = CrmStyles();
  return (
    <div className={classes.CRM}>
      <div className={classes.title}>
        <h1>CRM</h1>
      </div>
    </div>
  );
};

export default CRM;
